import { Radar } from 'react-chartjs-2';
import { defaultOptions } from '../../utils/chartConfig';

interface RadarChartProps {
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string;
      borderColor: string;
      pointBackgroundColor: string;
    }[];
  };
  height?: string;
}

export default function RadarChart({ data, height = '300px' }: RadarChartProps) {
  return (
    <div style={{ height }}>
      <Radar data={data} options={defaultOptions} />
    </div>
  );
}